// Activation-funnel clock. Measures how long a merchant takes to move from
// signup through the demo store to an accepted WhatsApp QR, plus how much
// active time they spend inside the demo store along the way.

export const JOURNEY_STORAGE_KEY = 'zoko_activation_journey'

// The activation funnel, in the order a merchant walks it. Stage names are
// deliberately short and stable — they are reported as event properties and
// grouped on in PostHog.
export const FUNNEL_STAGE = {
  signup: 'signup',
  demo_store: 'demo_store',
  meta_onboarding: 'meta_onboarding',
  qr_shown: 'qr_shown',
  qr_accepted: 'qr_accepted',
} as const

export type FunnelStage = (typeof FUNNEL_STAGE)[keyof typeof FUNNEL_STAGE]

// Index in this array is the stage's rank. Only forward moves advance the
// clock, so a merchant stepping back a screen never resets a stage timer.
export const STAGE_ORDER: FunnelStage[] = [
  FUNNEL_STAGE.signup,
  FUNNEL_STAGE.demo_store,
  FUNNEL_STAGE.meta_onboarding,
  FUNNEL_STAGE.qr_shown,
  FUNNEL_STAGE.qr_accepted,
]

// Active-time thresholds (minutes) that emit a one-off milestone event, so
// "spent 5+ minutes in the demo then connected" is a plain PostHog funnel
// rather than a HogQL query. Ascending order is required.
export const DEMO_MILESTONE_MINUTES = [1, 5, 15, 30]

export const MILLIS_PER_SECOND = 1000
export const SECONDS_PER_MINUTE = 60
